
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Ebene_2","data-name":"Ebene 2"}},[_c('text',{attrs:{"transform":"translate(16.49 35.17)","font-size":"36","font-family":"Arial-BoldMT,Arial","font-weight":"700","id":"Ebene_1-2","data-name":"Ebene 1"}},[_v('§')])])])
          )
        }
      }
    